(function () {
    'use strict';

    angular
        .module('observationModule')
        .controller('grcObservationFullController', Controller);

    Controller.$inject = ['$scope', '$state', 'grcObservationService', 'grcControlService', 'notificationService'];

    function Controller($scope, $state, grcObservationService, grcControlService, notificationService) {

        var observationBeforeChanges = $scope.boxModel;
        $scope.observation = _.cloneDeep(observationBeforeChanges);

        $scope.controlTest = $scope.boxContext.ControlTest;
        $scope.view = {};

        // Get Test Results
        if (!_.isUndefined($scope.controlTest)) {

            grcControlService
                .getTestResults($scope.controlTest.ControlID, $scope.controlTest.ControlTestID)
                .then(function (testResults) {
                    $scope.controlTestResults = testResults;
                });
        }

        // Show Reset Action?
        $scope.showResetAction = function () {
            return $scope.isPageDirty();
        };

        // Show Save Action?
        $scope.showSaveAction = function (form) {
            if (!$scope.observation.ObservationID) { return false; }

            return form.$valid && $scope.isPageDirty();
        };

        // Show Add Action?
        $scope.showAddAction = function (form) {

            if ($scope.observation.ObservationID) return false;

            if (_.isUndefined($scope.controlTestResults)) return false;
            if (_.isUndefined($scope.controlTestResults.ActualTestResult)) return false;

            return !form.$invalid;
        };

        // Show Add For Audit Mandate Action?
        $scope.showAddForAuditMandateAction = function (form) {

            if ($scope.observation.ObservationID) return false;
            if (!$scope.observation.GovernanceProcessID) return false;

            return !form.$invalid;
        };

        // Show Add For ODD Campaign?
        $scope.showAddForODDCampaignAction = function (form) {

            if ($scope.observation.ObservationID) return false;
            if (_.isUndefined($scope.observation.ODDCampaignID)) return false;

            return !form.$invalid;
        };

        // Show Delete Action?
        $scope.showDeleteAction = function () {
            // TODO: change to HasObservation_Delete when supported
            return $scope.observation.ObservationID && $scope.observation.HasObservation_Edit;
        };


        // Reset forms
        $scope.reset = function () {
            $state.reload();
        };

        // Show actions footer
        $scope.showActionsFooter = function () {
            if (!$scope.readOnly && ($scope.showSaveAction(form) || $scope.showAddAction(form) || $scope.showResetAction(form) || $scope.showAddForAuditMandateAction(form))) {
                return true;
            }
        }

        // Create Observation
        $scope.createObservation = function () {
            grcObservationService
                .createObservationFromTestResult($scope.controlTestResults.ActualTestResult.TestResultID, $scope.observation)
                .then(function (addedObservation) {
                    notificationService.notify('Observation has been added');
                    $state.go('observation.edit', {
                        ObservationID: addedObservation.ObservationID
                    }, {
                        reload: true
                    });

                    $scope.pageIsNotDirty();
                });
        };

        // Create Observation From Governance Process
        $scope.createObservationFromGovernanceProcess = function () {
            grcObservationService
                .createFromGovernanceProcess($scope.observation)
                .then(function (addedObservation) {
                    notificationService.notify('Observation has been added');
                    $state.go('observation.edit', {
                        ObservationID: addedObservation.ObservationID
                    }, {
                        reload: true
                    });

                    $scope.pageIsNotDirty();
                });
        };

        // Create Observation From ODD Campaign
        $scope.createObservationFromODDCampaign = function () {
            grcObservationService
                .createFromCampaign($scope.observation)
                .then(function (addedObservation) {
                    notificationService.notify('Observation has been added');
                    $state.go('observation.edit', {
                        ObservationID: addedObservation.ObservationID
                    }, {
                        reload: true
                    });

                    $scope.pageIsNotDirty();
                });
        };

        // Update Observation
        $scope.updateObservation = function () {

            grcObservationService
                .updateObservation($scope.observation)
                .then(function (updatedObservation) {
                    observationBeforeChanges = updatedObservation;
                    _.assign($scope.observation, updatedObservation);
                    notificationService.notify('Your changes have been saved');
                  
                    $scope.pageIsNotDirty();
                });
        };

        // Delete Observation
        $scope.deleteObservation = function () {
            grcObservationService
                .deleteObservation($scope.observation)
                .then(function () {
                    notificationService.notify('Observation has been deleted');
                    $scope.clickToBack();
                });
        };

        $scope.goToControlTest = function (item) {
            if (_.isUndefined(item.ControlID)) return;
            if (_.isUndefined(item.ControlTestID)) return;

            $state.go('control.controlTests.edit', {
                ControlID: item.ControlID,
                ControlTestID: item.ControlTestID
            });
        };

        // When selected recommendation
        $scope.whenSelectedRecommendation = function (recommendation) {
            $scope.addRecommendation({recommendation: recommendation});
        };

        // Control
        $scope.goToControl = function (item) {
            $state.go('control', { ControlID: item.ControlID });
        }
    }
})();